import { ActivitySpinnerSize, ActivitySpinnerWidget, DisplayValueFormatterProps } from '@tableau/widgets';
import React from 'react';
import _ from 'underscore';

import { imgPath } from '~src/commonInfra/utils/ImgUrl';

import { Formatters } from '../../../../codegen/Localize';
import { ExplorerStyles } from '../ExplorerStyles';
import { ExplorerDropdownStyles } from './ExplorerDropdownStyles';

const CHECK = 'explorer-dropdown-check.svg';
const CHECK_DISABLED = 'explorer-dropdown-check-disabled.svg';

export namespace ExplorerDropdownPanelItemTestIds {
  export const waiting = 'explorer-dropdown-panel-item-waiting';
  export const count = 'explorer-dropdown-panel-item-count';
}

interface ExplorerDropdownPanelItemProps {
  isChecked: boolean;
  text: string;
  displayCount: boolean;
  count?: number;
  countUpToDate?: boolean;
  header?: boolean;
  highlight?: boolean;
  disabled?: boolean;
}

const ExplorerDropdownPanelItem = (props: ExplorerDropdownPanelItemProps): JSX.Element => {
  let containerClass = ExplorerDropdownStyles.ExplorerDropdownItemContainer;
  if (props.header) {
    containerClass = ExplorerDropdownStyles.ExplorerDropdownItemHeaderContainer;
  } else if (props.highlight) {
    containerClass = ExplorerDropdownStyles.ExplorerDropdownSelectedItemContainer;
  } else if(props.disabled) {
    containerClass = ExplorerDropdownStyles.ExplorerDropdownDisabledItemContainer;
  }

  /* eslint-disable jsx-a11y/alt-text */
  return (
    <div className={containerClass} >
      <div className={ExplorerDropdownStyles.ExplorerDropdownItemCheckandNameContainer}>
        <div className={ExplorerDropdownStyles.ExplorerDropdownCheckImg}>
          {props.isChecked && <img className="checked" src={imgPath(props.disabled ? CHECK_DISABLED : CHECK)}/>}
        </div>
        {props.text}
      </div>
      {PanelItemCount(props)}
    </div>
  );
};

export const PanelItemCount = (props: { displayCount?: boolean, countUpToDate?: boolean, count?: number }): JSX.Element => {
  if (props.displayCount) {
    if (props.countUpToDate && !_.isUndefined(props.count) && !_.isNull(props.count)) {
      return <div className={ExplorerDropdownStyles.ExplorerDropdownCount}>
        <span data-tb-test-id={ExplorerDropdownPanelItemTestIds.count} data-raw-count={props.count}>
          {Formatters.formatCount(props.count)}
        </span>
      </div>;
    } else {
      return <div className={ExplorerDropdownStyles.ExplorerDropdownCount}>
        <ActivitySpinnerWidget testId={ExplorerDropdownPanelItemTestIds.waiting} spinnerSize={ActivitySpinnerSize.Small} />
      </div>;
    }
  }
  return null;
};

interface ExplorerDropdownPanelHeaderProps {
  text: string;
}

const ExplorerDropdownPanelHeader = (props: ExplorerDropdownPanelHeaderProps): JSX.Element => {
  return (
    <ExplorerDropdownPanelItem
      isChecked={false}
      text={props.text}
      header={true}
      displayCount={false}
    />
  );
};

export const ExplorerDropdownPanelSeparator = (): JSX.Element => {
  return (
    <div className={ExplorerDropdownStyles.ExplorerDropdownItemSeparator} />
  );
};

export const ExplorerDropdownItemHeaderFormatter = (displayValue: string): React.ComponentClass<DisplayValueFormatterProps> => {
  return class Formatter extends React.Component<DisplayValueFormatterProps> {
    public render(): JSX.Element {
      return (
        <ExplorerDropdownPanelHeader
          text={displayValue}
        />
      );
    }
  };
};

export const ExplorerDropdownSeparatorFormatter = (): React.ComponentClass<DisplayValueFormatterProps> => {
  return class Formatter extends React.Component<DisplayValueFormatterProps> {
    public render(): JSX.Element {
      return (
        <ExplorerDropdownPanelSeparator />
      );
    }
  };
};

export const ExplorerDropdownItemNoCountFormatter = (displayValue: string, checked: boolean): React.ComponentClass<DisplayValueFormatterProps> => {
  return class Formatter extends React.Component<DisplayValueFormatterProps> {
    public render(): JSX.Element {
      return (
        <ExplorerDropdownPanelItem
          isChecked={checked}
          text={displayValue}
          highlight={this.props.active || this.props.isHighlighted}
          disabled={this.props.disabled}
          displayCount={false}
        />
      );
    }
  };
};

export const ExplorerDropdownItemImageFormatter = (displayValue: string, checked: boolean, imgPathString: string): React.ComponentClass<DisplayValueFormatterProps> => {
  return class Formatter extends React.Component<DisplayValueFormatterProps> {
    public render(): JSX.Element {
      let containerClass = ExplorerDropdownStyles.ExplorerDropdownItemContainer;
      if (this.props.active || this.props.isHighlighted) {
        containerClass = ExplorerDropdownStyles.ExplorerDropdownSelectedItemContainer;
      }
      /* eslint-disable jsx-a11y/alt-text */
      return (
        <div className={containerClass} >
          <div className={ExplorerDropdownStyles.ExplorerDropdownItemCheckandNameContainer}>
            <div className={ExplorerDropdownStyles.ExplorerDropdownCheckImg}>
              {checked && <img src={imgPath(this.props.disabled ? CHECK_DISABLED : CHECK)} />}
            </div>
            {displayValue}
          </div>
          <img src={imgPathString} className={ExplorerStyles.ExplorerViewModeButtonImg} />
        </div>
      );
    }
  };
};
